import { render, staticRenderFns } from "./product-cover-by-dept.vue?vue&type=template&id=6a0ff8cc&scoped=true"
import script from "./product-cover-by-dept.vue?vue&type=script&lang=js"
export * from "./product-cover-by-dept.vue?vue&type=script&lang=js"
import style0 from "./product-cover-by-dept.vue?vue&type=style&index=0&id=6a0ff8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0ff8cc",
  null
  
)

export default component.exports